import localTermsSample from "../Data/TermAndCondition(Content7).json";

export const LOCAL_TERMS_SAMPLE = localTermsSample;

export const SAMPLE_TERMS_JSON = JSON.stringify(localTermsSample, null, 2);

const isTermsContentShape = (value) =>
  Boolean(value?.title && Array.isArray(value?.data));

export const getLocalTermsDisplay = () => ({
  ...localTermsSample,
  bannerName: localTermsSample.title,
  isLocalFallback: true,
});

export const normalizeTermsDisplay = (termsResponse) => {
  const fallback = getLocalTermsDisplay();
  const apiData = termsResponse?.data;

  if (!apiData || typeof apiData !== "object" || !isTermsContentShape(apiData)) {
    return fallback;
  }

  return {
    ...apiData,
    bannerName: apiData.title,
    meta: {
      updatedAt: termsResponse.updatedAt,
    },
    isLocalFallback: false,
  };
};

export const validateTermsJson = (parsed) => isTermsContentShape(parsed);
